import { Routes, mapToCanActivate } from '@angular/router';
import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';

import { SowsFeedAdviceDetailComponent } from './components/sows/sows-feed-advice-detail/sows-feed-advice-detail.component';

export const SowsFeedAdviceRoutes = (isReferenceFeedAdvice: boolean): Routes => [
  {
    path: 'create/:feedAdviceType',
    component: SowsFeedAdviceDetailComponent,
    data: { isReferenceFeedAdvice },
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
  },
  {
    path: 'edit/:id',
    component: SowsFeedAdviceDetailComponent,
    data: { isReferenceFeedAdvice },
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
  },
  {
    path: 'view/:id',
    component: SowsFeedAdviceDetailComponent,
    data: { isReferenceFeedAdvice },
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
  },
];
